import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FlameIcon, MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    label: 'The Forge',
    href: '#what'
  }, {
    label: 'Paths',
    href: '#paths'
  }, {
    label: 'Stories',
    href: '#stories'
  }, {
    label: 'Doctrine',
    href: '#philosophy'
  }, {
    label: 'Podcast',
    href: '#podcast'
  }];
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[var(--forge-black)]/95 backdrop-blur-md border-b border-[var(--forge-steel)]' : 'bg-transparent'}`} data-id="element-46">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-47">
          <Link to="/" className="flex items-center gap-2 group" data-id="element-48">
            <FlameIcon className="w-8 h-8 text-[var(--forge-lava)] group-hover:scale-110 transition-transform" data-id="element-49" />
            <span className="text-2xl font-black tracking-tighter" data-id="element-50">
              THE FORGE
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8" data-id="element-51">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-sm font-semibold text-[var(--forge-gray)] hover:text-[var(--forge-lava)] transition-colors" data-id="element-52">
                {link.label}
              </a>)}
            <Link to="/apply" data-id="element-53">
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="px-6 py-2 bg-[var(--forge-lava)] text-white font-bold text-sm tracking-wide hover:bg-[var(--forge-lava-glow)] transition-colors" data-id="element-54">
                APPLY
              </motion.button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-[var(--forge-white)]" data-id="element-55">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-56" /> : <MenuIcon className="w-6 h-6" data-id="element-57" />}
          </button>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-58">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        x: '100%'
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: '100%'
      }} className="fixed inset-0 z-40 bg-[var(--forge-black)] md:hidden pt-20" data-id="element-59">
            <div className="flex flex-col items-center gap-6 p-8" data-id="element-60">
              {navLinks.map(link => <a key={link.label} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-2xl font-bold text-[var(--forge-white)] hover:text-[var(--forge-lava)] transition-colors" data-id="element-61">
                  {link.label}
                </a>)}
              <Link to="/apply" onClick={() => setIsMobileMenuOpen(false)} data-id="element-62">
                <button className="mt-4 px-8 py-3 bg-[var(--forge-lava)] text-white font-bold text-lg tracking-wide" data-id="element-63">
                  APPLY
                </button>
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}